import React from 'react';
import { useTranslation } from '../../../hooks';
import styles from './GovBar.module.css';

/**
 * GovBar Component
 * 
 * Official government identity bar that appears at the top of the page.
 * Displays the official platform announcement in both Arabic and English.
 * 
 * Features:
 * - Bilingual official text
 * - Government-style styling
 * - Accessibility compliance
 * - CSS Modules for scoped styling
 * - Responsive design
 * 
 * @component
 * @example
 * return (
 *   <GovBar />
 * )
 */
const GovBar = () => {
  const { language } = useTranslation();
  const isAR = language === 'ar';

  return (
    <div 
      className={styles.govBar} 
      role="banner" 
      aria-label={isAR ? 'شريط رسمي للبلدة' : 'Official Municipality Bar'}
    >
      <div className={styles.container}>
        <span className={styles.officialText}>
          {isAR 
            ? 'المنصة الرقمية الرسمية لبلدة قاقعية الجسر' 
            : 'Official Digital Platform of Qaqaaiyat AlJiser Municipality'
          }
        </span>
      </div>
    </div>
  );
};

export default GovBar;